import { Box, Link, Paper, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import WidgetError from 'components/Dashboard/components/WidgetError';
import WidgetLoadingIndicator from 'components/Dashboard/components/WidgetLoadingIndicator';
import WidgetHeading from '../../components/WidgetHeading';
import { TRss } from './constants';
import { PropsRefType } from './RssLayout';
import { ErrorBoundary } from 'react-error-boundary';

type Props = {
  rssFeed: TRss[] | undefined;
  viewportRef: PropsRefType;
  isLoading: boolean;
  isError: boolean;
  id: string;
};

const RssListCards = ({ rssFeed, viewportRef, isLoading, isError, id }: Props) => {
  const descriptionCharacterLimit = 80;

  return (
    <Paper
      ref={viewportRef}
      id={id}
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr',
        gap: 1,
        p: 2,
      }}
    >
      <WidgetHeading sx={{ mt: 1 }}>Software Releases</WidgetHeading>

      {/* Content. */}
      <ErrorBoundary fallback={<WidgetError />}>
        {isLoading ? (
          <WidgetLoadingIndicator />
        ) : isError ? (
          <WidgetError />
        ) : (
          <>
            <Link
              data-testid="help-release-notes-link"
              rel="noopener"
              to="https://www.bloxdigital.com/releases/software_releases/"
              target="_blank"
              color="primary"
              component={RouterLink}
              sx={{
                mb: 1,
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: '14px',
                  textDecoration: 'underline',
                }}
              >
                View All Release Notes
              </Typography>
            </Link>

            {rssFeed?.map((rss, i) => {
              return (
                <Box
                  key={rss?.guid || i}
                  onClick={() => window.open(rss.link, '_blank')}
                  sx={(theme) => ({
                    backgroundColor:
                      theme.palette.mode === 'light'
                        ? theme.blox.colors.gray5
                        : theme.blox.colors.offblack,
                    p: 1,
                    borderRadius: 2,
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor:
                        theme.palette.mode === 'light'
                          ? theme.blox.colors.gray6
                          : theme.blox.colors.darkgray,
                    },
                  })}
                >
                  <Typography
                    variant="subtitle2"
                    gutterBottom
                  >
                    {rss.title}
                  </Typography>

                  <Typography
                    variant="subtitle1"
                    sx={theme => ({
                      color: theme.palette.mode === 'light'
                        ? theme.blox.colors.offblack
                        : theme.blox.colors.lightgray,
                    })}
                  >
                    {!!rss?.description &&
                    rss?.description?.length > descriptionCharacterLimit
                      ? `${rss.description?.substring(0, descriptionCharacterLimit)}...`
                      : rss.description}
                  </Typography>
                </Box>
              );
            })}
          </>
        )}
      </ErrorBoundary>
    </Paper>
  );
};

export default RssListCards;
